var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSucess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.5015 0C36.04 0 0 36.041 0 80.5C0 124.962 36.0371 161 80.5015 161C124.96 161 161 124.965 161 80.5C161 36.0439 124.963 0 80.5015 0ZM81.4789 116.347C77.9829 120.979 71.3902 121.892 66.767 118.399L34.6604 94.1251C30.0431 90.6351 29.1244 84.0457 32.6262 79.414C36.1192 74.794 42.712 73.8753 47.3293 77.3682L71.0614 95.305L104.518 51.0485C108.014 46.4227 114.604 45.5098 119.227 49.0027C123.85 52.4985 124.769 59.0879 121.27 63.7137L81.4789 116.347Z",
    fill: "#16C96F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucess);
export default __webpack_public_path__ + "static/media/sucess.129692b0e48335105fdcbb1bc7789abb.svg";
export { ForwardRef as ReactComponent };